export const ESI_PATIENT_GET = 'esi-patient-get';
export const ESI_PATIENT_GET_RESULT = ESI_PATIENT_GET + '/result';
export const ESI_PATIENT_GET_ERROR = ESI_PATIENT_GET + '/error';
